import { EntityReference, Money, OptionsetItem, GUID, BaseEntity } from './base/base';

export class GeneratedCredentials extends BaseEntity {

	_credentialsId: GUID;

	_name: string;

	_password?: string;

	_profilefields?: string;

	_role?: OptionsetItem;

	_surname?: string;

	_username: string;

	_createdOnBehalfBy?: EntityReference;

	_importSequenceNumber?: Number;

	_modifiedOnBehalfBy?: EntityReference;

	_overriddenCreatedOn?: Date;

	_ownerId: EntityReference;

	_owningBusinessUnit?: EntityReference;

	_owningTeam?: EntityReference;

	_owningUser?: EntityReference;

	_statecode: OptionsetItem;

	_statuscode?: OptionsetItem;

	_timeZoneRuleVersionNumber?: Number;

	_uTCConversionTimeZoneCode?: Number;

	_versionNumber?: Number;
	constructor() {
		super('credentialsId');
	}

	get credentialsId(): GUID
	{
		return this._credentialsId;
	};
	set credentialsId(val: GUID)
	{
		this._id = val;
		this._credentialsId = val;
		this._attributeValues['credentialsId'] = this._credentialsId;
	};

	get name(): string
	{
		return this._name;
	};
	set name(val: string)
	{
		this._name = val;
		this._attributeValues['name'] = this._name;
	};

	get password(): string
	{
		return this._password;
	};
	set password(val: string)
	{
		this._password = val;
		this._attributeValues['password'] = this._password;
	};

	get profilefields(): string
	{
		return this._profilefields;
	};
	set profilefields(val: string)
	{
		this._profilefields = val;
		this._attributeValues['profilefields'] = this._profilefields;
	};

	get role(): OptionsetItem
	{
		return this._role;
	};
	set role(val: OptionsetItem)
	{
		this._role = val;
		this._attributeValues['role'] = this._role;
	};

	get surname(): string
	{
		return this._surname;
	};
	set surname(val: string)
	{
		this._surname = val;
		this._attributeValues['surname'] = this._surname;
	};

	get username(): string
	{
		return this._username;
	};
	set username(val: string)
	{
		this._username = val;
		this._attributeValues['username'] = this._username;
	};

	get createdOnBehalfBy(): EntityReference
	{
		return this._createdOnBehalfBy;
	};
	set createdOnBehalfBy(val: EntityReference)
	{
		this._createdOnBehalfBy = val;
		this._attributeValues['createdOnBehalfBy'] = this._createdOnBehalfBy;
	};

	get importSequenceNumber(): Number
	{
		return this._importSequenceNumber;
	};
	set importSequenceNumber(val: Number)
	{
		this._importSequenceNumber = val;
		this._attributeValues['importSequenceNumber'] = this._importSequenceNumber;
	};

	get modifiedOnBehalfBy(): EntityReference
	{
		return this._modifiedOnBehalfBy;
	};
	set modifiedOnBehalfBy(val: EntityReference)
	{
		this._modifiedOnBehalfBy = val;
		this._attributeValues['modifiedOnBehalfBy'] = this._modifiedOnBehalfBy;
	};

	get overriddenCreatedOn(): Date
	{
		return this._overriddenCreatedOn;
	};
	set overriddenCreatedOn(val: Date)
	{
		this._overriddenCreatedOn = val;
		this._attributeValues['overriddenCreatedOn'] = this._overriddenCreatedOn;
	};

	get ownerId(): EntityReference
	{
		return this._ownerId;
	};
	set ownerId(val: EntityReference)
	{
		this._ownerId = val;
		this._attributeValues['ownerId'] = this._ownerId;
	};

	get owningBusinessUnit(): EntityReference
	{
		return this._owningBusinessUnit;
	};
	set owningBusinessUnit(val: EntityReference)
	{
		this._owningBusinessUnit = val;
		this._attributeValues['owningBusinessUnit'] = this._owningBusinessUnit;
	};

	get owningTeam(): EntityReference
	{
		return this._owningTeam;
	};
	set owningTeam(val: EntityReference)
	{
		this._owningTeam = val;
		this._attributeValues['owningTeam'] = this._owningTeam;
	};

	get owningUser(): EntityReference
	{
		return this._owningUser;
	};
	set owningUser(val: EntityReference)
	{
		this._owningUser = val;
		this._attributeValues['owningUser'] = this._owningUser;
	};

	get statecode(): OptionsetItem
	{
		return this._statecode;
	};
	set statecode(val: OptionsetItem)
	{
		this._statecode = val;
		this._attributeValues['statecode'] = this._statecode;
	};

	get statuscode(): OptionsetItem
	{
		return this._statuscode;
	};
	set statuscode(val: OptionsetItem)
	{
		this._statuscode = val;
		this._attributeValues['statuscode'] = this._statuscode;
	};

	get timeZoneRuleVersionNumber(): Number
	{
		return this._timeZoneRuleVersionNumber;
	};
	set timeZoneRuleVersionNumber(val: Number)
	{
		this._timeZoneRuleVersionNumber = val;
		this._attributeValues['timeZoneRuleVersionNumber'] = this._timeZoneRuleVersionNumber;
	};

	get uTCConversionTimeZoneCode(): Number
	{
		return this._uTCConversionTimeZoneCode;
	};
	set uTCConversionTimeZoneCode(val: Number)
	{
		this._uTCConversionTimeZoneCode = val;
		this._attributeValues['uTCConversionTimeZoneCode'] = this._uTCConversionTimeZoneCode;
	};

	get versionNumber(): Number
	{
		return this._versionNumber;
	};
	set versionNumber(val: Number)
	{
		this._versionNumber = val;
		this._attributeValues['versionNumber'] = this._versionNumber;
	};
}



// WEBPACK FOOTER //
// ./src/app/schemas/codegen/GeneratedCredentials.ts